module.exports = __webpack_public_path__ + "static/why2-99c61b1b90e175567dcabf1e74d8ba58.jpg";